import React from 'react';
import { getCredentialingPracticePanelList } from 'api/credentialing';
import type { TProviderPanelGroup } from 'types/credentialing';

let globalData: TProviderPanelGroup[] = [];

const usePracticePanels = (enabled = true): [TProviderPanelGroup[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TProviderPanelGroup[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingPracticePanelList();
            if (!result.error) {
                const list: TProviderPanelGroup[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        if (enabled) fetchData();
    }, [fetchData, enabled]);

    return [data, loading, fetchData];
};

export default usePracticePanels;
